import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Env from 'shared/env'
import { NotificationPreviewPopup } from './Popup'
import { useFetch } from '../../../commons/Hooks/useFetch'
import { useOutsideClick } from '../../../commons/Hooks/useOutsideClick'

export function NotificationPreviewButton({ isLoggedIn, token }) {
  const config = { headers: { Authorization: `Bearer ${token}`} }
  const url = `${Env.pnsPublicWebApiHost()}/inbox`

  const popupRef = useRef(null)
  const [visible, setVisible] = useState(false)
  const { data, error, loaded } = useFetch(url, config)

  useOutsideClick(popupRef, () => { setVisible(false) })

  if (!loaded || error || !isLoggedIn) {
    return null
  }

  const showPopup = () => {
    !visible ? setVisible(true) : setVisible(false)
  }

  const notificationIcon = visible
    ? 'notification-preview-button__icon-show'
    : 'notification-preview-button__icon-hide' 

  return (
    <div ref={popupRef}>
      <button
        onClick={showPopup}
        className={`notification-preview-button notifications__icon ${notificationIcon}`}
      />
      {visible ? <NotificationPreviewPopup data={data} /> : null}
    </div>
  )
}

NotificationPreviewButton.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  token: PropTypes.string.isRequired
}